//region :: Imports ::
import {ICustomProperties} from '@microsoft/applicationinsights-web';
import IMLogger from './ILogger';
import ConsoleLogger from './ConsoleLogger';
import AppInsightsLogger from './AppInsightsLogger';
import Environment from '../../Environment';

//endregion

/** */
class MLogger {

    /** */
    private static getLogger(): IMLogger {
        return Environment.isLocal || Environment.isDevelopment ? new ConsoleLogger() : new AppInsightsLogger();
    }

    /** */
    public static trackInfo(message: string, properties?: ICustomProperties): void {
        MLogger.getLogger().trackInfo(message, properties);
    }

    /** */
    public static trackWarning(message: string, properties?: ICustomProperties): void {
        MLogger.getLogger().trackWarning(message, properties);
    }

    /** */
    public static trackError(error: Error, properties?: ICustomProperties): void {
        MLogger.getLogger().trackError(error, properties);
    }

}

export default MLogger;
